export const externalLinkMixin = (url: string) =>
  /^https?:\/\//.exec(url)
    ? {
        target: '_blank',
        rel: 'noopener noreferrer',
      }
    : {};
